import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PaginationResponse } from '../shared/models/pagination-response.model';

export interface CassAccount {
  id: number;
  client_id: number;
  site_id: number;
  site_number: string;
  service_types: string;
  vendor_id: string;
  vendor_name: string;
  account_number: string;
  account_name: string;
  account_address1: string;
  account_address2: string;
  account_city: string;
  account_state: string;
  account_postal_code: string;
  account_country: string;
  account_effective_date: string;
  account_inactive_date: string;
  last_updated_on: string;
  type: string;
  regeneration_status: string;
  last_regenerated_on: string;
  last_regenerated_by: string;
  conflicts_count: number;
}

export interface CassRelatedAccount {
  id: number;
  account_number: string;
  account_name: string;
  vendor_id: string;
  vendor_name: string;
  type: string;
}

export interface CassBillTypeConflict {
  id: number;
  account_number: string;
  begin_date: string;
  end_date: string;
  process_date: string;
}

@Injectable({
  providedIn: 'root',
})
export class CassAccountsService {
  apiBase = environment.apiBase;

  constructor(private http: HttpClient) { }

  list(params?): Observable<PaginationResponse<CassAccount>> {
    const page = params && params.page ? params.page : 1;
    const pageSize = params && params.pageSize ? params.pageSize : 10;

    return this.http.post<PaginationResponse<CassAccount>>(`${this.apiBase}/cass/accounts/detail/queryPage?pageNumber=${page}&pageSize=${pageSize}`, params);
  }

  get(id: number): Observable<CassAccount> {
    return this.http.get<CassAccount>(`${this.apiBase}/cass/accounts/detail/${id}`);
  }

  updateType(id: number, type: string) {
    return this.http.put(`${this.apiBase}/cass/accounts/updateType`, { id, type });
  }

  getActiveRelatedAccounts(id: number): Observable<CassRelatedAccount[]> {
    return this.http.get<{ related_accounts: CassRelatedAccount[] }>(`${this.apiBase}/cass/accounts/activeRelatedAccounts/${id}`).pipe(
      map(res => res.related_accounts || []),
    );
  }

  getBillTypeConflicts(id: number): Observable<CassBillTypeConflict[]> {
    return this.http.get<{ bills: CassBillTypeConflict[] }>(`${this.apiBase}/cass/accounts/billTypeConflicts/${id}`).pipe(
      map(res => res.bills || []),
    );
  }

  // the csv report is downloaded in a new tab, with the grid filters and sorting as query string parameters
  exportCsv(params: { [key: string]: string | boolean }) {
    const query = Object.keys(params)
      .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(String(params[key]))}`)
      .join('&');

    window.open(`${this.apiBase}/cass/accounts/csvReport${query ? '?' + query : ''}`, '_blank');
  }

  regenerateBills(id: number,includeRelatedAccounts = false) {
    return this.http.post(`${this.apiBase}/cass/accounts/regenerateBills`, { id, include_related_accounts: includeRelatedAccounts });
  }
}
